import LoginPage from "./login/login-page"
import ProtectedRoute from "@/routes/protected-route"

import AdminPages from "./admin/admin-pages"
import AdminAptPage from "./admin/apt/admin-apt-page"
import AdminAptUnitSizePage from "./admin/apt/[apt_code]/unit-size/admin-apt-unit-size-page"
import AdminUserPage from "./admin/user/admin-user-page"
import AdminGroupPage from "./admin/group/admin-group-page"
import AdminLogPage from "./admin/log/admin-log-page"

import PdfPrint from "./(pdf)/pdf-print"
import SimulatorEntryPage from "./simulator/simulator-page"
import SimulatorResultPage from "./simulator/result/simulator-result-page"
import SelectPage from "./select/select-page"
import AptSelectPage from "./select/apt/apt-select-page"
import OrgSelectPage from "./select/org/org-select-page"
import OrgPage from "./org/org-page"
import AptPages from "./apt/apt-pages"
import OverviewPage from "./apt/[apt_code]/overivew/overview-page"
import ReportPage from "./apt/[apt_code]/report/report-page"
import AnalysisPage from "./apt/[apt_code]/analysis/analysis-page"
import UnitsPage from "./apt/[apt_code]/units/units-page"
import { Navigate, Route } from "react-router-dom"
import MonitoringPage from "./apt/[apt_code]/monitoring/monitoring-page"
import MyPageLayout from "./my/my-page-layout"
import MyPage from "./my/my-page"
import PW_VerifyPage from "./my/pw/verify/pw-verify-page"
import PW_ChangePage from "./my/pw/change/pw-change-page"
import { overviewLoader } from "./apt/[apt_code]/overivew/overview-loader"
import { protectedLoader } from "./protected-loader"
import Loading from "@/components/loading"
import { reportLoader } from "./apt/[apt_code]/report/report-loader"
import { monitoringLoader } from "./apt/[apt_code]/monitoring/monitoring-loader"
import { analysisLoader } from "./apt/[apt_code]/analysis/analysis-loader"
import { unitsLoader } from "./apt/[apt_code]/units/units-loader"
import ErrorPage from "@/components/error-page"
import { orgLoader } from "./org/org-loader"
import { aptSelectLoader } from "./select/apt/apt-select-loader"

export const pageRoutes = [
  {
    path: "/",
    el: LoginPage
  },
  {
    el: ProtectedRoute,
    loader: protectedLoader,
    HydrateFallback: Loading,
    children: [
      {
        path: "/select",
        el: SelectPage
      },
      {
        path: "/select/apt",
        el: AptSelectPage,
        loader: aptSelectLoader
      },
      {
        path: "/select/org",
        el: OrgSelectPage
      },
      {
        path: "/org/:org",
        el: OrgPage,
        loader: orgLoader
      },
      {
        path: "/my",
        el: MyPageLayout,
        children: [
          {
            index: true,
            el: MyPage
          },
          {
            path: "pw/verify",
            el: PW_VerifyPage
          },
          {
            path: "pw/change",
            el: PW_ChangePage
          }
        ]
      },
      {
        path: "/apt/:region/:aptCode",
        el: AptPages,
        children: [
          {
            path: "overview",
            el: OverviewPage,
            loader: overviewLoader,
            errorElement: ErrorPage
          },
          {
            path: "monitoring",
            el: MonitoringPage,
            loader: monitoringLoader
          },
          {
            path: "report",
            el: ReportPage,
            loader: reportLoader
          },
          {
            path: "analysis",
            el: AnalysisPage,
            loader: analysisLoader
          },
          {
            path: "units",
            el: UnitsPage,
            loader: unitsLoader
          }
        ]
      },
      {
        path: "/admin",
        el: AdminPages,
        children: [
          {
            index: true,
            element: <Navigate to="apt" replace />
          },
          {
            path: "apt",
            el: AdminAptPage
          },
          {
            path: "apt/:aptCode/unit-size",
            el: AdminAptUnitSizePage
          },
          {
            path: "user",
            el: AdminUserPage
          },
          {
            path: "group",
            el: AdminGroupPage
          },
          {
            path: "log",
            el: AdminLogPage
          }
        ]
      }
    ]
  },
  {
    path: "/pdf",
    el: PdfPrint
  },
  {
    path: "/simulator",
    el: SimulatorEntryPage
  },
  {
    path: "/simulator/result",
    el: SimulatorResultPage
  },
  {
    path: "*",
    element: <Navigate to="/select" replace />
  }
]

export const createRoutes = (routes) => {
  return routes.map(({ path, el: Component, element, children, ...props }) => (
    <Route
      key={path ?? Component?.name ?? "route"}
      path={path}
      element={element ?? (Component ? <Component /> : undefined)}
      {...props}
    >
      {children && createRoutes(children)}
    </Route>
  ))
}
